import React from "react";
import { Popup } from "semantic-ui-react";
import { string, node, object } from "prop-types";

export const ActionMenuTooltip = ({ trigger, state, tooltips }) => {
  if (!tooltips[state]) {
    return <>{trigger}</>;
  }

  return <Popup trigger={<div>{trigger}</div>} content={tooltips[state]} />;
};

ActionMenuTooltip.propTypes = {
  state: string.isRequired,
  trigger: node.isRequired,
  tooltips: object.isRequired,
};
